import React from "react";
import {View, StyleSheet, TouchableOpacity} from "react-native";
import {styleVars} from "../../../app-style-vars";
import PtRadioButtons from "../../core/pt-radio-buttons";
import {getTranslation} from "../../../helpers/getTranslation";
import PtDateTimeRange from "../../core/pt-date-time-picker/pt-date-time-range";
import PtText from "../../core/pt-text/pt-text";
import {PtOrderHistoryFilterProps} from './pt-order-history-filter-props';


const tomorrow = new Date().setDate(new Date().getDate() + 1);
const yearAgo = new Date(tomorrow).setFullYear(new Date(tomorrow).getFullYear() - 1);

export default function PtOrderHistoryFilter(props: PtOrderHistoryFilterProps) {

  /** labels */
  const orderStatusTitle = props.filtersOptions?.orderStatus?.title ? props.filtersOptions.orderStatus.title : 'Order status';
  /** data */
  const orderStatusChoices = props.filtersOptions?.orderStatus?.choices ?
    props.filtersOptions.orderStatus.choices
    : []
  const orderDateRangeTitle = props.filtersOptions?.orderDate?.title ? props.filtersOptions.orderDate.title : 'Order date';
  const startDateLabel = props.filtersOptions?.orderDate?.startDateLabel ? props.filtersOptions.orderDate.startDateLabel : 'From date';
  const endDateLabel = props.filtersOptions?.orderDate?.endDateLabel ? props.filtersOptions.orderDate.endDateLabel : 'To date';
  const startDate = props.requestParams.startDate;
  const endDate = props.requestParams.endDate;
  const minDate = props.filtersOptions?.orderDate?.minDate ? props.filtersOptions.orderDate.minDate : yearAgo;
  const maxDate = props.filtersOptions?.orderDate?.maxDate ? props.filtersOptions.orderDate.maxDate :  new Date();

  /** settings */
  const filtersContainerStyle = props.show ? styles.filtersContainerShown : null;

  /** pass through handlers */
  const orderStatusFilterChangedHandler = props.orderStatusFilterChangedHandler;
  const startDateChangedHandler = props.startDateChangedHandler;
  const endDateChangedHandler = props.endDateChangedHandler;

  const applyFilters = () => {
    props.applyFiltersHandler();
  }

  return (
    <View style={[styles.filtersContainer, filtersContainerStyle]}>
      <View style={[styles.filtersWrapper]}>
        <View style={[styles.radioButtonsContainer]}>
          <PtRadioButtons
            title={orderStatusTitle}
            buttons={orderStatusChoices}
            requestParams={props.requestParams}
            initialValue = {props.requestParams.orderStatus1}
            valueChangedHandler = {orderStatusFilterChangedHandler}
          />
        </View>
        <View style={[styles.datePickerContainer]}>
          <PtDateTimeRange
            title={orderDateRangeTitle}
            dateFromLabel={startDateLabel}
            dateToLabel={endDateLabel}
            requestParams={props.requestParams}
            startDate={props.requestParams.startDate || startDate}
            endDate={props.requestParams.endDate || endDate}
            minDate={minDate}
            maxDate={maxDate}
            startDateChangedHandler = {startDateChangedHandler}
            endDateChangedHandler = {endDateChangedHandler}
          />
        </View>
      </View>
      <View style={[styles.applyFiltersContainer]}>
        <TouchableOpacity onPress={() => applyFilters()}>
          <View style={[styles.applyFiltersButton]}>
            <PtText style={[styles.applyButtonText]}>{getTranslation('order.history.apply.button.label')}</PtText>
          </View>
        </TouchableOpacity>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  filtersContainer: {
    paddingVertical: styleVars.rem(.5),
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    display: 'none',
    zIndex: 2
  },
  filtersContainerShown: {
    display: 'flex',
  },
  filtersWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    zIndex: 2
  },
  radioButtonsContainer: {
    minWidth: 300
  },
  datePickerContainer: {
    minWidth: 300
  },
  applyFiltersContainer: {
    justifyContent: 'center',
    width: '100%',
    maxWidth: 300
  },
  applyFiltersButton: {
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: styleVars.boschDarkBlue,
    height: styleVars.rem(2.5),
    paddingHorizontal: styleVars.rem(1),
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 0,
  },
  applyButtonText: {
    color: styleVars.boschDarkBlue
  }
})